import React from 'react';
import { AgxRow, AgxButton, Breakpoints, useWindowSize } from '@urbanx/agx-ui-components';
import { Icon_HomeOutline } from '@urbanx/agx.ui-components2';
import './DesktopHeader.scss';
import { useAppSelector } from 'hooks/useAppSelector';
import IconBubble from 'layout/components/IconBubble';
import AutopilotLogo from 'layout/assets/images/Autopilot-logo.svg?react';

interface DesktopHeaderProps {
  onBackToCampaigns: () => void;
  formId?: string;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ onBackToCampaigns, formId }) => {
  const logo = useAppSelector(
    (state) => state.agencies.agencyInfo.info?.branding?.logo?.publicPath
  );

  const screenSize = useWindowSize();
  const isMobile = screenSize === Breakpoints.Mobile;
  const isTabletPortrait = screenSize === Breakpoints.Tablet_Portrait;

  return (
    <>
      {(!formId || (formId && !isMobile && !isTabletPortrait)) && (
        <AgxRow centered fill spaceBetween extraClasses="desktopHeader">
          {logo ? (
            <img className="headerLogo" src={logo} alt="Property Logo" />
          ) : (
            <AutopilotLogo className="headerLogo" />
          )}
          {isMobile || isTabletPortrait ? (
            <IconBubble
              image={<Icon_HomeOutline color="var(--fg-brand-main)" height={20} width={20} />}
              onClick={onBackToCampaigns}
              extraClasses="backButton"
            />
          ) : (
            <AgxButton
              id="btn-back"
              text="Back"
              primary
              medium
              onClick={onBackToCampaigns}
              extraClasses="backButton"
            />
          )}
        </AgxRow>
      )}
    </>
  );
};
